import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) { navigate("/admin/login"); return; }

    (async () => {
      try {
        const { data } = await axios.post(`${API}/auth/session`, {}, {
          headers: { "X-Session-ID": sessionId },
          withCredentials: true,
        });
        setUser(data);
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { state: { user: data } });
      } catch {
        navigate("/admin/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#1A1514]">
      <Loader2 className="w-8 h-8 text-[#B85C38] animate-spin" />
    </div>
  );
}
